import scrollama from 'scrollama';

const archiveIntroEl = document.querySelector('.c-intro--archive');

if (archiveIntroEl) {
  const archiveDecoText = archiveIntroEl.querySelector('.c-intro__deco-text');

  if (archiveDecoText) {
    const introScroll = scrollama();

    introScroll
      .setup({
        step: archiveIntroEl,
        progress: true,
        offset: 0.15,
      })
      .onStepProgress(({ progress }) => {
        archiveDecoText.style.opacity = `calc(1 - ${progress})`;
      });
  }
}



// WEBPACK FOOTER //
// ./src/scripts/modules/intro.js